import { styled } from '@flex-design-system/stitches-react';
import TextareaAutosize from 'react-textarea-autosize';

const commonInputStyle = {
  color: "$grayDarker",
  background: "transparent",
  "&&": {
    /**
     * https://flex-cv82520.slack.com/archives/C02U6EBG9U1/p1660284289801899
     * fds global style보다 높은 우선순위로 적용되도록 한다. 추후 fds가 없어지면 제거한다.
     */
    "&::placeholder": {
      color: "$grayLight",
      opacity: 1,
      fontWeight: 500
    }
  },
  variants: {
    state: {
      error: {
        color: "$orange",
        "&&": {
          "&::placeholder": {
            color: "$orange"
          }
        }
      },
      default: {}
    }
  }
};
const StyledInput = styled("input", commonInputStyle);
const StyledTextArea = styled(TextareaAutosize, {
  ...commonInputStyle,
  lineHeight: 1.5,
  whiteSpace: "pre-line",
  resize: "none"
});

export { StyledInput, StyledTextArea };
//# sourceMappingURL=styled.mjs.map
